module.exports = __webpack_public_path__ + "img/svg/hour.901c79ff93fec9475a6505918194c80f.svg";